import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { t } = useTranslation();

  const trustIndicators = [
    { icon: 'ri-shield-check-line', text: (t('home.cta.indicators', { returnObjects: true }) as string[])[0] },
    { icon: 'ri-customer-service-line', text: (t('home.cta.indicators', { returnObjects: true }) as string[])[1] },
    { icon: 'ri-global-line', text: (t('home.cta.indicators', { returnObjects: true }) as string[])[2] },
  ];

  return (
    <section className="relative py-28 overflow-hidden bg-[#050008]">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a0040] via-[#050008] to-[#001a2e]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,rgba(140,82,255,0.3)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_50%,rgba(0,194,255,0.2)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(255,45,170,0.15)_0%,transparent_50%)]" />

      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#8c52ff]/50 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00c2ff]/30 to-transparent" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/5 border border-[#FF2DAA]/30 rounded-full px-4 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-[#FF2DAA] animate-pulse" />
          <span className="text-[#FF2DAA] text-xs font-bold uppercase tracking-widest">{t('home.cta.badge')}</span>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
          {t('home.cta.titlePrefix')}
          <span className="block bg-gradient-to-r from-[#8c52ff] via-[#FF2DAA] to-[#00c2ff] bg-clip-text text-transparent">
            {t('home.cta.titleHighlight')}
          </span>
        </h2>

        <p className="text-white/60 text-base md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto">
          {t('home.cta.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://smartbusiness.academy"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#8c52ff] to-[#FF2DAA] text-white font-bold px-8 py-4 rounded-full hover:opacity-90 hover:scale-105 transition-all duration-300 text-base shadow-lg shadow-purple-500/40 cursor-pointer"
          >
            <i className="ri-graduation-cap-line" />
            {t('home.cta.buttons.academy')}
          </a>
          <a
            href="mailto:info@smartbusinessdigital.com"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white/5 backdrop-blur-sm border border-white/20 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 hover:border-[#00c2ff]/50 transition-all duration-300 text-base cursor-pointer"
          >
            <i className="ri-calendar-line" />
            {t('home.cta.buttons.consult')}
          </a>
          <Link
            to="/services"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white/5 backdrop-blur-sm border border-white/20 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 hover:border-[#8c52ff]/50 transition-all duration-300 text-base cursor-pointer"
          >
            <i className="ri-compass-3-line" />
            {t('home.cta.buttons.services')}
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-14">
          {trustIndicators.map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-white/40">
              <i className={`${item.icon} text-[#8c52ff]`} />
              <span className="text-sm">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
